import { BottomSheet, Text, TypeOptionRendererProps } from '@thefarmersfront/kitchen-mobile';

import OptionRefetchButton from './OptionRefetchButton';

import styles from './WorkInfoBottomSheet.module.scss';

const WorkInfoBottomSheet = ({
  open = false,
  options,
  onChange,
  setOpen,
  title,
  onOptionsRefetch,
  onClose,
}: TypeOptionRendererProps & { title: string; onOptionsRefetch?: () => void; onClose?: () => void }) => {
  return (
    <BottomSheet
      className={styles['work-info-bottom-sheet']}
      id="work-info-bottom-sheet"
      open={open}
      title={title}
      showButton={false}
      onClose={() => {
        setOpen?.(false);
        onClose?.();
      }}
    >
      <div className={styles['bottom-sheet-container']}>
        {options?.map((option, index) => {
          const keyOfButton = `button-${option.value}-${option.text}-${index}`;
          const disabled = 'isActive' in option && !option?.isActive;
          return (
            <button
              key={keyOfButton}
              disabled={disabled}
              className={styles['bottom-sheet-button']}
              onClick={(e) => {
                onChange?.(option, e);
                setOpen?.(false);
              }}
            >
              <Text size="xlarge" color={disabled ? 'disabled' : 'primary'}>
                {option?.text}
              </Text>
            </button>
          );
        })}
        <OptionRefetchButton show={options?.length === null} onRefetch={onOptionsRefetch} />
      </div>
    </BottomSheet>
  );
};

export default WorkInfoBottomSheet;
